function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { useState, cloneElement } from "react";
import { findComponent } from "@brandwatch/axiom-utils";
import Position from "../Position/Position";
import PositionSource from "../Position/PositionSource";
import PositionTarget from "../Position/PositionTarget";
import { TooltipSourceRef } from "./TooltipSource";
import { TooltipTargetRef } from "./TooltipTarget";
/**
 * Uses the Position component to show content on hover.
 */

const Tooltip = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    delay = false,
    onClick,
    position = "top",
    enabled = true,
    ...rest
  } = _ref;
  const [isVisible, setIsVisible] = useState(false);
  React.useImperativeHandle(ref, () => ({
    showTooltip,
    hideTooltip
  }));

  function showTooltip() {
    if (enabled && !isVisible) {
      setIsVisible(true);
    }
  }

  function hideTooltip() {
    setIsVisible(false);
  }

  return /*#__PURE__*/React.createElement(Position, _extends({}, rest, {
    enabled: enabled,
    isVisible: isVisible,
    position: position,
    showArrow: true
  }), /*#__PURE__*/React.createElement(PositionTarget, {
    delay: delay,
    onClick: onClick
  }, /*#__PURE__*/cloneElement(findComponent(children, TooltipTargetRef), {
    showTooltip,
    hideTooltip
  })), /*#__PURE__*/React.createElement(PositionSource, null, findComponent(children, TooltipSourceRef)));
});
Tooltip.displayName = "Tooltip";
export default Tooltip;